/* eslint-disable */

import axios from "axios";
import moment from "moment";
import { tz } from "../../../utils/timezone";

const url = require("../../client_config/config").url;

const state = {
  unverified: [],
  unsigned: [],
  loading: false,
  snackbar: { show: false, text: "", color: "green accent-4" },
  exceptionDialog: false,
  selectedMedication: [],
};

const getters = {
  getUnsignedData: (state) => state.unsigned,
  getUnverifiedMAR: (state) => state.unverified,
};

const actions = {
  async getUnsigned({ commit }, data) {
    try {
      const response = await axios.get(`${url}/MAR/unsigned/${data.id}`);
      const mars = response.data.data.map((item) => {
        item.Date = moment(item.Date).format("YYYY-MM-DD");
        return {
          ...item,
          Date: tz(item.Date, data.userTimezone).format("YYYY-MM-DD"),
        };
      });
      commit("SET_MAR", mars);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  //fetch client unverified MAR
  async getClientUnverifiedMAR({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/mar/all/unverified/${id}`);
      if (response.data.success) {
        commit("SET_ALL_UNVERIFIED", response.data.mar);
        commit("SET_LOADING", false);
      }
      return response.data.mar;
    } catch (error) {
      console.error(error.response);
      commit("SET_LOADING", false);
      return error.response;
    }
  },

  //Add MAR
  async addMAR({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/MAR`, data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },

  //update and verify MAR
  async verifyMAR({ commit }, { id, data }) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.put(`${url}/mar/verify/${id}`, data);
      if (response.data.success) {
        commit("SET_UNVERIFIED", data);
        commit("SET_LOADING", false);
      }
      return response.data;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async updateMARItem({ commit }, { data, id, unsigned }) {
    try {
      const response = await axios.put(`${url}/MAR/${id}`, data, {
        params: { unsigned }
      });
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async downloadMARReport({ commit }, data) {

    try {
      const response = await axios.get(`${url}/MAR/download-report`, {
        params: data,
        responseType: 'arraybuffer'
      }
    );
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },
};

const mutations = {
  SET_MAR(state, data) {
    state.unsigned = data;
  },

  SET_ALL_UNVERIFIED(state, data) {
    state.unverified = [];
    data.map((item) => {
      item.Date = moment(item.Date).format("YYYY-MM-DD");
      state.unverified.push(item);
    });
  },

  SET_UNVERIFIED(state, data) {
    state.unverified = state.unverified.filter(
      (item) => !data.selectedIds.includes(item._id)
    );
  },

  SET_LOADING(state, data) {
    state.loading = data;
  },

  SET_EXCEPTION_DIALOG(state, data) {
    state.exceptionDialog = data;
  },

  SET_SELECTED_MEDICATION(state, data) {
    state.selectedMedication = data;
  },
  SET_SNACKBAR(state, { show, text, color }) {
    let timeout = 0;

    if (state.snackbar.show) {
      state.snackbar.show = false;
      timeout = 100;
    }
    setTimeout(() => {
      state.snackbar = {
        show: show,
        text: text,
        color: color,
      };
    }, timeout);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
